const INITIAL_STATE = {
  data: {},
  errors: {},
}

const residentialRegister = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'RESIDENTIAL_REGISTER_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data, message:"residential-registered" }
  case 'RESIDENTIAL_REGISTER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'CREATE_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'CREATE_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data, message:"lead-updated"}
  case 'UPDATE_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'CLEAN_RESIDENTIAL_REGISTER_RESPONSE':
    return {...INITIAL_STATE}
  default:
    return { ...state }
  }
};
    
export default residentialRegister;